var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({style:(_vm.computedStyles),attrs:{"src":_vm.imageURL},on:{"click":function($event){return _vm.ttsShow()}}},'img',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }